import React from "react";
import { useLocation } from "react-router-dom";
import whatsappLogo from "../assets/whatsapp.png";

/**
 * Fixed floating WhatsApp contact button shown across the site, letting
 * visitors start a chat directly. Hidden on the AI search page to avoid
 * competing with the AI assistant UI.
 */
export default function FloatingWhatsapp() {
    const location = useLocation();
    const whatsappNumber = "918309120616";

    if (location.pathname === "/ai-search") return null;

    return (
        <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                zIndex: 9999,
            }}
        >
            <img
                src={whatsappLogo}
                alt="WhatsApp"
                style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                    cursor: "pointer",
                }}
            />
        </a>
    );
}
